declare const KTComponents: any;
declare const KTMenu: any;

import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../guards/StorageService';
import { PermissionService } from '../../api-services/Permission/permission.service';
import { AuthService } from '../../api-services/AdminHRService/Login/auth.service';

@Component({
  selector: 'app-admin-sidebar',
  standalone: false,
  templateUrl: './admin-sidebar.component.html',
  styleUrl: './admin-sidebar.component.css'
})
export class AdminSidebarComponent implements AfterViewInit {
  sidebarMenu: any = {};
  EmployeeName : any;
  DesignationName : any;
  profileUrl: string = '';

  constructor(
    private router: Router,
    public storageService: StorageService,
    private readonly permissionService: PermissionService,
    private readonly authService : AuthService
  ) { }

  ngOnInit(): void {
    this.permissionService.restore();
    this.sidebarMenu = this.permissionService.getSidebarStructure();
    this.EmployeeName = this.authService.getUser()?.employeeName;
    this.DesignationName = this.authService.getUser()?.designation;
    this.profileUrl = this.permissionService.getProfileUrl(this.router.url);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }

      if (typeof KTComponents !== 'undefined') {
        KTComponents.init();
      }
    }, 100);
  }

   btnSignOut() {
    this.authService.logout();
    this.permissionService.clear();
    this.storageService.clearAll();
    this.router.navigateByUrl('/SignIn');
  }

}
